import React, { useMemo, useState, useEffect } from 'react';
import { WizardPage } from '@xengage/gw-portals-wizard-react';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { useDependencies } from '@xengage/gw-portals-dependency-react';
import { Loader } from '@jutro/components';
import { useTranslator } from '@jutro/locale';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { MLModalService , MLTagManagerService } from 'ml-portals-services-react';
import { MLRewriteService } from 'ml-capability-rewrite';
import { AvailableDocumentsComponent } from 'gw-capability-policychange-common-react';
import { GatewayDocumentService } from 'gw-capability-gateway-document';
import { MLFormService } from 'ml-services-common-react';
import { platformMessages } from 'ml-components-platform-react';


import Rewrite from '../../model/Rewrite';

import metadata from './MLRewriteAvailableDocumentsPage.metadata.json5';
import messages from './MLRewriteAvailableDocumentsPage.messages';
import styles from './MLRewriteAvailableDocumentsPage.module.scss'

function MLRewriteAvailableDocumentsPage(props){

    const {
        updateWizardData, wizardData, goNext, currentStep
    } = props;
    const { submissionVM } = wizardData;
    const { authHeader } = useAuthentication();
    const translator = useTranslator();
    const { UserService } = useDependencies('UserService');
    const [isLoading, setIsLoading] = useState(true);
    const [isUserRetentionAgent, setIsUserRetentionAgent] = useState(false);

    const ModalService = MLModalService();


    const shouldSkip = () => {
        return !!currentStep.stepHidden
    }

    useEffect(() => {
        if(shouldSkip()){
            goNext();
        }else{
            UserService.getCurrentUser(authHeader).then((user) => {
                setIsUserRetentionAgent(user.isIA)
                setIsLoading(false);
            })
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const convertDateToUTC = (date) =>{
        if (date) {
            return date.toLocaleString('en-US', { timeZone: 'UTC', month: 'numeric', day: 'numeric', year: '2-digit', hour: '2-digit', minute: '2-digit'});
        }
        return '';
    };  
    
    const viewDocument = (item) => {
        MLTagManagerService.sendLinkClickEvent('view_'.concat(item.value.formDescription));
        /*
        const sessionID = endorsementVM.sessionUUID.value;
        const foreignId = endorsementVM.jobID.value;
        const documentNotFoundURL = `${window.location.pathname.substring(0, window.location.pathname.lastIndexOf('/'))}/PolicyDocumentError`;

        const appendToUrl = `${foreignId}?form=${item.formNumber.value}&token=${sessionID}&portalRoute=${documentNotFoundURL}`;
    
        const displayErrorModal = () => {
            showErrorModal(platformMessages.error, platformMessages.unableToDownloadDocument)
        };

        return GatewayDocumentService.downloadDocumentPreview(appendToUrl, authHeader, displayErrorModal);
        */
    };
    const allForms = submissionVM.forms_ML;

    const verbalAuthForms = useMemo(() => {
        return allForms.filter((form) => {
            return form.verbalAuthorization_ML.value === true;
        })
    }, [allForms]);

    const eSignatureForms = useMemo(() => {
        return allForms.filter((form) => {
            return form.esigned_ML.value === true && !(form.verbalAuthorization_ML.value === true && form.isSigned.value === true);
        })
    }, [allForms]);

    const availableDocumentsForms = useMemo(() => {
        return [...new Set(verbalAuthForms.concat(eSignatureForms))];
    }, [eSignatureForms, verbalAuthForms]);

    const onNext = () => {
        const updateFormPromise = MLFormService.updateForms(submissionVM.jobNumber.value, submissionVM.forms_ML.value, authHeader);
        ModalService.showProgressDialog(platformMessages.loading, updateFormPromise);
        updateFormPromise.then(() => {
            ModalService.hideProgressDialog();
            submissionVM.value.portalCurrentStep_ML = currentStep.mlStepName
            const promise = MLRewriteService.bind(submissionVM.value, authHeader);
            ModalService.showProgressDialog(messages.bind, promise);
            promise.then((result) => {
                submissionVM.value = new Rewrite(result);
                updateWizardData(wizardData);
                goNext();
            });
            promise.catch((error) => {
                error.modalTitle = translator(messages.bindErrorTitle);
                error.modalMessage =  translator(messages.bindErrorMessage);
                throw error;
            });
        })
    }

    const overrideProps = {
        availableDocuments: {
            availableDocumentsForms,
            isUserRetentionAgent,
            convertDateToUTC,
            viewDocument
        },
        nextDescription: {
            content: <>{translator(messages.nextDescription, { strong: (chunks) => <strong>{chunks}</strong> })}</>
        }
    };

    const resolvers = {
        resolveClassNameMap: styles,
        resolveCallbackMap: {
            onNext
        },
        resolveComponentMap: {
            AvailableDocumentsComponent
        }
    }

    if (isLoading) {
        return <Loader loaded={!isLoading} />;
    }

    return (
        <WizardPage
            showCancel={false}
            showNext={false}
            showPrevious={false}
        >
            <ViewModelForm
                uiProps={metadata.pageContent}
                model={wizardData}
                overrideProps={overrideProps}
                onModelChange={updateWizardData}
                classNameMap={resolvers.resolveClassNameMap}
                callbackMap={resolvers.resolveCallbackMap}
                componentMap={resolvers.resolveComponentMap}
                
            />
        </WizardPage>
    );
}

export default MLRewriteAvailableDocumentsPage;